<div class="wrapper">
	<mat-table matSort (matSortChange)="onSortChange($event)" [dataSource]="tableDataSource()">
		<ng-container matColumnDef="checkbox" class="mat-cell-id" sticky>
			<mat-header-cell *matHeaderCellDef class="mat-cell-id"></mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index" class="mat-cell-id">
				<mat-checkbox
					color="primary"
					[(ngModel)]="element.checked"
					(click)="checkMultipleSelection($event, i)"
				></mat-checkbox>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="id">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-id"> Id</mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-id" [class.text-danger]="element.stopSale"
				>{{ element.id }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Nazwa</mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big" [class.text-danger]="element.stopSale"
				>{{ element.name }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="kind">
			<mat-header-cell *matHeaderCellDef class="mat-cell-kind"> Typ </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-kind justify-content-center">
				<i
					[ngClass]="{
						'fa-bus': element.kind === OfferTransportKind.COACH,
						'fa-plane': element.kind === OfferTransportKind.PLANE,
					}"
					class="fas"
				></i>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="departureTime">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Wyjazd</mat-header-cell>
			<mat-cell [class.text-danger]="element.stopSale" *matCellDef="let element" class="mat-cell-date">
				{{ element.departureTime | date: 'yyyy-MM-dd' }}
				{{ element.departureTimeDay }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="accommodationLower">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Zakwaterowanie</mat-header-cell>
			<mat-cell [class.text-danger]="element.stopSale" *matCellDef="let element" class="mat-cell-date">
				<ng-container *ngIf="element?.accommodation?.lower">
					{{ element.accommodation.lower }}
					{{ element.accommodation.lowerDay }}
				</ng-container>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="accommodationUpper">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Wykwaterowanie</mat-header-cell>
			<mat-cell [class.text-danger]="element.stopSale" *matCellDef="let element" class="mat-cell-date">
				<ng-container *ngIf="element?.accommodation?.upper">
					{{ element.accommodation.upper }}
					{{ element.accommodation.upperDay }}
				</ng-container>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="returnTime">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Powrót</mat-header-cell>
			<mat-cell [class.text-danger]="element.stopSale" *matCellDef="let element" class="mat-cell-date"
				>{{ element.returnTime | date: 'yyyy-MM-dd' }} {{ element.returnTimeDay }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="sumOfTransportDeparture">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<span class="me-2"
					><i
						class="fas fa-circle-info"
						matTooltip="{{ tableDataSource().data | countValueTransportTerm: 'departure' }}"
					></i
				></span>
				Wyjazd
			</mat-header-cell>
			<mat-cell *matCellDef="let element" [class.text-danger]="element.stopSale">
				{{ element.slots.departureConfirm }} ({{ element.reservations.departureConfirm }}) /
				{{ element.slots.departureSlotsCountOptional }} ({{
					element.reservations.departureReservationCountOptional
				}}) /0
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="sumOfTransportReturn">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<span class="me-2"
					><i
						class="fas fa-circle-info"
						matTooltip="{{ tableDataSource().data | countValueTransportTerm: 'return' }}"
					></i
				></span>
				Powrót
			</mat-header-cell>
			<mat-cell *matCellDef="let element" [class.text-danger]="element.stopSale"
				>{{ element.slots.returnConfirm }} ({{ element.reservations.returnConfirm }}) /
				{{ element.slots.returnSlotsCountOptional }} ({{ element.reservations.returnReservationCountOptional }})
				/0
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="accomodation">
			<mat-header-cell *matHeaderCellDef> Pokoje</mat-header-cell>
			<mat-cell [class.text-danger]="element.stopSale" *matCellDef="let element">0 (0) /0 (0) /0</mat-cell>
		</ng-container>
		<ng-container matColumnDef="status">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Status</mat-header-cell>

			<mat-cell *matCellDef="let element; let index = index" class="mat-cell-status" [ngClass]="element.color">
				<mat-select
					panelWidth="null"
					[(ngModel)]="element.status"
					[name]="'elementStatus' + index"
					(selectionChange)="changeStatus(element)"
				>
					<mat-option
						[value]="item.value"
						*ngFor="let item of parameters()?.statuses"
						class="mat-cell-status"
					>
						{{ item.viewValue }}
					</mat-option>
				</mat-select>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="organizationStatus">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Status organizacja </mat-header-cell>

			<mat-cell *matCellDef="let element; let index = index" class="mat-cell-status">
				<mat-select
					panelWidth="null"
					[ngModel]="element.organizationStatus?.id"
					(selectionChange)="changeOrganizationStatus(element, $event.value)"
				>
					<mat-option [value]="null"></mat-option>
					@for (item of parameters()?.organizationStatuses; track item.name) {
						<mat-option [value]="item.id" class="mat-cell-status">
							{{ item.name }}
						</mat-option>
					}
				</mat-select>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="touristGuides">
			<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Pilot </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				<ng-container *ngIf="element.touristGuides?.length">
					{{ element.touristGuides[0] }}
					<button
						mat-mini-fab
						color="primary"
						class="mx-1 disabled"
						*ngIf="element.touristGuides?.length > 1"
						matTooltip="{{ element.touristGuides.slice(1) }}"
					>
						+ {{ element.touristGuides?.length - 1 }}
					</button>
				</ng-container>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="highlightLastSeats">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Ostatnie miejsca </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2 reversed"
					[(ngModel)]="element.highlightLastSeats"
					(change)="patchHighlightLastSeats(element)"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="confirmTime">
			<mat-header-cell *matHeaderCellDef> Data do potwierdzenia </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.owuConfirmationDate }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="swinging">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Wypoczynek </mat-header-cell>
			<mat-cell *matCellDef="let element"> {{ element.swinging ? 'Tak' : 'Nie' }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="stopSale" stickyEnd>
			<mat-header-cell *matHeaderCellDef class="mat-cell-date"> StopSale </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2 reversed"
					[(ngModel)]="element.stopSale"
					(change)="patchStopSale(element)"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="markAsPopular" stickyEnd>
			<mat-header-cell *matHeaderCellDef class="mat-cell-date"> Popularne </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2 reversed"
					[(ngModel)]="element.markAsPopular"
					(change)="patchMarkAsPopular(element)"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="responsibleUser">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Osoba odpowiedzialna </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (!!element.responsibleUser) {
					{{ element.responsibleUser?.firstName }} {{ element.responsibleUser?.lastName }}
				} @else {
					<span class="text-danger"> Nieprzypisano </span>
				}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="earliestDeadline">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-date"> Termin wykonania</mat-header-cell>
			<mat-cell [class.text-danger]="element.stopSale" *matCellDef="let element" class="mat-cell-date"
				>{{ element.earliestDeadline | date: 'yyyy-MM-dd' }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="menu" stickyEnd>
			<mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<button class="menuBtn" mat-icon-button [matMenuTriggerFor]="menu">
					<i class="fa-solid fa-ellipsis-vertical"></i>
				</button>
				<mat-menu #menu="matMenu">
					<button (click)="openAssignDialog(element)" mat-menu-item>
						<span>Przypisz</span>
					</button>
					<button (click)="openFilesDialog(element)" mat-menu-item>
						<span>Pliki</span>
					</button>
					<button (click)="openCheckListDialog(element)" mat-menu-item>
						<span>Check-listy</span>
					</button>
					<button (click)="openStopSalesDialog(element)" mat-menu-item>
						<span>Stop Sale miast</span>
						@if (element.blockedTimetableCount && element.blockedTimetableCount > 0) {
							<span class="ms-2 badge bg-danger">{{ element.blockedTimetableCount }}</span>
						}
					</button>
					<button (click)="jumpToProduct(element)" mat-menu-item>
						<span>Produkt</span>
					</button>
					<button class="menuItemShowMore" (click)="openDialog(element)" mat-menu-item>
						<span>Więcej</span>
					</button>
				</mat-menu>
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
		<mat-row
			*matRowDef="let row; let element; columns: displayedColumns()"
			[style.backgroundColor]="element.organizationStatus?.color"
		></mat-row>
	</mat-table>

	@if (isLoading()) {
		<div class="spinner-container">
			<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
		</div>
	}
</div>

@if (showPaginator()) {
	<div class="footer">
		<mat-paginator
			(page)="pageChanged($event)"
			[pageIndex]="page()"
			[pageSizeOptions]="[10, 20, 50]"
			[pageSize]="50"
			[length]="allItemsSize()"
			showFirstLastButtons
			aria-label="Select page of periodic elements"
		>
		</mat-paginator>
	</div>
}
